import React from 'react';
import { Input } from 'antd';
import { useFieldController } from '../../../helpers/formManager';
import FormFieldItem from './FormFieldItem';
import { fieldNames } from '../constants';

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const rules = {
  validate: (value) =>
    !value?.trim() ||
    emailPattern.test(value.trim()) ||
    'Укажите корректный email',
};

const EmailField = ({ control, disabled }) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useFieldController({ control, name: fieldNames.email, rules });

  return (
    <FormFieldItem label="Email" errorMessage={error?.message}>
      <Input
        value={value}
        onChange={onChange}
        disabled={disabled && Boolean(value?.trim())}
      />
    </FormFieldItem>
  );
};

export default EmailField;
